import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';

import { getStyle } from '@coreui/coreui/dist/js/coreui-utilities';
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips';
import { GridComponent, GridDataResult, DataStateChangeEvent, RowClassArgs } from '@progress/kendo-angular-grid';
import { GroupDescriptor, SortDescriptor, process, State } from '@progress/kendo-data-query';
import { DialogService, DialogCloseResult } from '@progress/kendo-angular-dialog';

// import { EventInput } from '@fullcalendar/core';
// import { FullCalendarComponent } from '@fullcalendar/angular';
// import dayGridPlugin from '@fullcalendar/daygrid';
// import timeGrigPlugin from '@fullcalendar/timegrid';
// import interactionPlugin from '@fullcalendar/interaction';

import { ContextService } from '@app/auth/context.service';
import { NgEventBus } from 'ng-event-bus';

import { Customer, Machine, Device, Event, WeldSession } from '@app/shared/sdk/models';
import { CustomerApi, MachineApi, EventApi, DeviceApi, WeldSessionApi } from '@app/shared/sdk/services';

import * as moment from 'moment';
import Tooltip from 'tooltip.js';

import { SessionGraphFormComponent } from './session-graph-form/session-graph-form.component';
import { MqttService } from 'ngx-mqtt/src/mqtt.service';
import { IMqttMessage } from 'ngx-mqtt';
import { Observable } from 'rxjs';
import { trigger, style, animate, transition, keyframes, state } from '@angular/animations';
import { Message, MessageControllerService } from '@app/shared/sdk/services/weldtrack';


@Component({
  selector: 'dashboard-view',
  templateUrl: 'dashboard.component.html',
  styleUrls: ['dashboard.component.css'],
  animations: [
    trigger('positiveState', [
      transition('void => *', []),
      transition('* => void', []),
      transition('* => *', [
        animate(
          1500,
          keyframes([style({ backgroundColor: '#32CD32', offset: 0.0 }), style({ backgroundColor: 'inherit', offset: 1.0 })])
        )
      ])
    ]),
    trigger('fadeInOut', [
      state('0', style({ color: ' rgb(149, 149, 149)' })),
      state('1', style({ color: 'green' })),
      transition('0 <=> 1', animate('1s')),
    ]),
  ]
})
export class DashboardComponent implements OnInit, OnDestroy {
  private subscription = [];

  // Grid parameters
  public state: State = {
    group: Array<GroupDescriptor>(),
    sort: Array<SortDescriptor>(),
    skip: 0,
    take: 20
  };
  private pageSize = 0;
  private operators: any[];
  public loading: boolean = false;
  public operatorData: GridDataResult;

  public showNoSession: boolean = true;
  public showOpenSession: boolean = true;
  public showExecutingSession: boolean = true;
  public showWarningSession: boolean = true;

  private devices: any[]
  public gridData: Observable<any>;
  // grid parameters
  public refreshInterval;

  // @ViewChild('calendar') calendarComponent: FullCalendarComponent;
  // private calendarPlugins = [dayGridPlugin, timeGrigPlugin, interactionPlugin];
  // private calendarEvents: EventInput[] = [];
  mqttEventObserve: Observable<IMqttMessage>;

  // operator sessions
  constructor(
    private eventBus: NgEventBus,
    private dialogService: DialogService,
    private deviceApi: DeviceApi,
    private mqttService: MqttService,
    private messageControllerService: MessageControllerService,
    private weldSessionApi: WeldSessionApi
  ) {
    this.mqttService.observe('/mqtt/events').subscribe((message: IMqttMessage) => {
      console.log(message.payload.toString())
    });
    this.mqttEventObserve = this.mqttService.observe(`/mqtt/events/message/#`);
    const query = this.getQuery();
    //TODO paginattion
    // let dataCount = this.getCount()
    this.gridData = this.fetchData();

    this.subscription.push(this.eventBus.on('area:active').subscribe((area) => {
      // this.deviceApi.count(query.where).subscribe((dataCount) => {
      this.gridData = this.fetchData();
      // })
    }));


  };
  //TODO pagination
  // async getCount(){
  //   const query = this.getQuery();
  //   return await this.deviceApi.count(query.where)
  // }

  fetchData(): Observable<any> {

    return new Observable((observer) => {
      const query = this.getQuery()
      this.deviceApi.find(query).subscribe((devices) => {
        this.messageControllerService.messageControllerLastMessage().subscribe((lastMessage) => {
          let dataGrid = []
          devices.forEach((element: any) => {
            let date = lastMessage.filter((lm) => lm._id === element.serialNumber)
            let sessionStatus = false;
            let customer = '';
            if (element.machine !== undefined && element.machine !== null) {
              if (element.machine.weldSessions !== undefined && element.machine.weldSessions.length > 0) {
                sessionStatus = (element.machine.weldSessions[0].closeDate) ? false : true;
                if (element.machine.weldSessions[0].customer !== undefined && element.machine.weldSessions[0].customer !== null)
                  customer = element.machine.weldSessions[0].customer.firstName + ' ' + element.machine.weldSessions[0].customer.lastName
              }
            }
            dataGrid.push({
              deviceName: element.serialNumber,
              wifi: false,
              gsm: false,
              sync: false,
              lastWeld: date[0] ? date[0].date : '',
              asignMachine: (element.machine !== undefined && element.machine !== null) ? element.machine.code : '',
              sessionStatus: sessionStatus,
              sessionUser: customer,
              updateData: false,
              dataGraph: {
                current: [],
                voltage: [],
                power: []
              },
              statusConnection: function (message: IMqttMessage) {
                const device = element.serialNumber
                const con = JSON.parse(message.payload.toString());
                let wifi = false;
                let gsm = false;
                switch (con.type) {
                  case 'wifi':
                    wifi = true
                    break;
                  case 'gsm':
                    gsm = true
                    break;
                }
                this.devices = dataGrid.map((row) => {
                  if (row.deviceName === device) {
                    row.wifi = wifi
                    row.gsm = gsm
                  }
                  return row
                })
                observer.next(this.devices)
              },
              intervalStatusConnection: setInterval(() => {
                const device = element.serialNumber
                this.devices = dataGrid.map((row) => {
                  if (row.deviceName === device) {
                    row.wifi = false
                    row.gsm = false
                    row.sync = false
                  }
                  return row
                })
                observer.next(this.devices)
                this.mqttService.publish(`/ping/${element.deviceName}`, element.deviceName).subscribe((success) => {
                }, err => console.log(err))
              }, 5.2 * 60 * 1000)
            });

            this.mqttService.observe(`/pong/${element.serialNumber}`).subscribe(dataGrid[dataGrid.length - 1].statusConnection);
          });

          this.mqttService.observe(`/mqtt/events/message`).subscribe(function (message: IMqttMessage) {
            let data = JSON.parse(message.payload.toString());
            if (data.payload)
              data = data.payload
            data.current = Number(data.current)
            data.power = Number(data.power)
            data.voltage = Number(data.voltage)
            let updateData = false
            this.devices = dataGrid.map((row) => {
              if (row.deviceName === data.deviceSerialNumber) {
                row.lastWeld = data.date
                row.updateData = (row.updateData) ? false : true;
                updateData = true
              }
              return row
            });
            if (updateData)
              observer.next(this.devices)
          })
          this.mqttService.observe(`/mqtt/events/lost/#`).subscribe(function (message: IMqttMessage) {
            const data = JSON.parse(message.payload.toString());
            let updateData = false
            this.devices = dataGrid.map((row) => {
              if (row.deviceName === data.deviceSerialNumber) {
                row.sync = true,
                  // row.updateData = true
                  updateData = true
              }
              return row
            });
            if (updateData)
              observer.next(this.devices)
          })
          this.mqttService.observe(`/mqtt/events/remove/#`).subscribe(function (message: IMqttMessage) {
            const data = JSON.parse(message.payload.toString());
            let updateData = false
            this.devices = dataGrid.map((row) => {
              if (row.deviceName === data.deviceSerialNumber) {
                row.sync = false,
                  // row.updateData = true
                  updateData = true
              }
              return row
            });
            if (updateData)
              observer.next(this.devices)
          })
          this.mqttService.observe('/mqtt/sessions/#').subscribe(async (message: IMqttMessage) => {
            let session = JSON.parse(message.payload.toString());
            let updateData = false
            this.devices = dataGrid.map(async (row) => {
              if (row.asignMachine === session.machineCode) {
                row.sessionStatus = (message.topic === '/mqtt/sessions/openned') ? true : false,
                  updateData = true
                if (session.weldSessionId !== undefined) {
                  session = await this.weldSessionApi.findOne({ where: { id: session.weldSessionId }, include: ['machine', 'customer'] }).toPromise();
                  row.sessionUser = session.customer.lastName + ', ' + session.customer.firstName;
                }
              }
              return row
            });
            if (updateData)
              observer.next(this.devices)
          });
          this.devices = dataGrid
          this.devices.forEach((element: any) => {
            this.mqttService.publish(`/ping/${element.deviceName}`, element.deviceName).subscribe((success) => {
            }, err => console.log(err))
          })
          observer.next(this.devices)
        }, err => {
          console.log(err)
        });
      }, err => {
        console.log(err)
      })
    })
  }
  public rowCallback = (context: RowClassArgs): { [Key: string]: boolean } => {
    // console.log(context)
    return {}

  };
  ngOnInit(): void {

  }

  public onQueryClick(event: any) {
    this.devices.forEach((element: any) => {
      this.mqttService.publish(`/ping/${element.deviceName}`, element.deviceName).subscribe((success) => {
        console.log(success)
      }, err => console.log(err))
    })
  }


  public dataStateChange(state: DataStateChangeEvent): void {
    this.loading = true
    this.state = state;
    let query = this.getQuery();
    if (state.sort.length > 0) {
      state.sort.forEach((e) => query.order.push(`${e.field} ${e.dir.toUpperCase()}`))
    }
    if (state.filter && state.filter.filters.length > 0) {
      query.where = { ...this.getWhere(state.filter.filters) }

    }
    //TODO pagination
    // this.deviceApi.find(query.where).subscribe((dataCount) => {
    //   this.deviceApi.find(query).subscribe((data) => {
    //     // this.welds = data;
    //     // this.loadGrid(this.devices, dataCount.count);

    //     this.loading = false;
    //   },
    //     err => {
    //       console.log(err);
    //       this.loading = false;
    //     });
    // },
    //   err => {
    //     console.log(err);
    //     this.loading = false;
    //   });
    // this.loadGrid(this.machines);
  }
  //TODO pagination
  public pageChange(state: any): void {
    this.loading = true
    this.state.skip = state.skip;
    this.state.take = state.take;
    let query = {
      skip: state.skip,
      limit: state.take,
      order: [],
      where: {}
    }
    if (this.state.sort.length > 0) {
      this.state.sort.forEach((e) => query.order.push(`${e.field} ${e.dir.toUpperCase()}`))
    }
    if (this.state.filter && this.state.filter.filters.length > 0) {
      query.where = this.getWhere(this.state.filter.filters)

    }
    //TODO pagination
    // this.messageControllerService.messageControllerCount(query.where).subscribe((dataCount) => {
    //   this.messageControllerService.messageControllerFind(query).pipe(map((datum) => datum.map((m: Message) => {
    //     if (m.date != undefined)
    //       m.date = new Date(m.date);
    //     return m;
    //   }))).subscribe((data) => {
    //     // this.welds = data;
    //     // this.loadGrid(this.welds, dataCount.count);

    //     this.loading = false;
    //   },
    //     err => {
    //       console.log(err);
    //       this.loading = false;
    //     });
    // },
    //   err => {
    //     console.log(err);
    //     this.loading = false;
    //   });
  }
  public getWhere(filters) {
    let where = { and: [] };
    filters.forEach((el: any) => {
      let expresions = { [el.logic]: [] }
      el.filters.forEach((e) => {
        switch (e.operator) {
          case 'isnull': expresions[el.logic].push({ [e.field]: { 'like': e.value } }); break;
          case 'contains': expresions[el.logic].push({ [e.field]: { 'like': e.value } }); break;
          case 'doesnotcontain': expresions[el.logic].push({ [e.field]: { 'nlike': e.value } }); break;
          case 'eq': expresions[el.logic].push({ [e.field]: e.value }); break;
          case 'neq': expresions[el.logic].push({ [e.field]: { 'neq': e.value } }); break;
          case 'startswith': expresions[el.logic].push({ [e.field]: { 'regexp': new RegExp(`^${e.value}`) } }); break;
          case 'endswith': expresions[el.logic].push({ [e.field]: { 'regexp': new RegExp(`$${e.value}`) } }); break;
          case 'gte': expresions[el.logic].push({ [e.field]: { 'gte': e.value } }); break;
          case 'gt': expresions[el.logic].push({ [e.field]: { 'gt': e.value } }); break;
          case 'lte': expresions[el.logic].push({ [e.field]: { 'lte': e.value } }); break;
          case 'lt': expresions[el.logic].push({ [e.field]: { 'lt': e.value } }); break;
          default: break;
        }
      })
      where.and.push(expresions)
    })
    return where
  }

  private getQuery() {
    let query: any = {
      skip: this.state.skip,
      limit: this.state.take,
      // order: [],
      where: { areaId: ContextService.context.area.id },
      include: [
        {
          relation: 'machine',
          scope: {
            include: [
              {
                relation: 'weldSessions',
                scope: {
                  order: "openDate DESC",
                  limit: 1,
                  include: [
                    { relation: 'customer' }
                  ]
                }
              }]
          },
        }
      ]
    }

    return query;
  }
  public changeData(event, data) {
    console.log(data)
  }
  public showSessionGraph(event, dataItem) {
    // const weldSession: WeldSession = dataItem.weldSession; 
    // const machine: Machine = weldSession.machine; 
    // const device: Device = weldSession.machine.device; 

    const dialogRef = this.dialogService.open({
      title: 'Gráfica Vibración RMS',
      content: SessionGraphFormComponent,
      width: 800
    });

    const weldSessionGraphEditForm = dialogRef.content.instance;
    // weldSessionGraphEditForm.weldSession = 1//weldSession;
    // weldSessionGraphEditForm.machine = //machine;
    weldSessionGraphEditForm.device = dataItem.deviceName;//device;
    weldSessionGraphEditForm.data = dataItem.dataGraph;
    dialogRef.result.subscribe((machine: any) => {
    });
  }
  ngOnDestroy(): void {
    this.subscription.forEach(sub => sub.unsubscribe());
    if (this.refreshInterval)
      this.refreshInterval.unsubscribe();
  }
}
